// 异常件记录

const abnormal = [
  {
    path: '/abnormal-record',
    name: 'abnormalRecordPage',
    meta: { tag: '异常件记录' },
    component: () => import('@/pages/AbnormalRecordPage')
  },
  {
    path: '/no-parts-record',
    name: 'noPartsRecordPage',
    meta: { tag: '无备件工单' },
    component: () => import('@/pages/PmpRecordPage/no-parts')
  }
]

export default abnormal
